<template>
  <!-- 购买发票豆 -->
  <div>
    <dialogModel
      title="购买发票豆"
      width="720px"
      :visible.sync="VisibleBuyBean"
      @handleClose="handleClose"
      @handleOk="handleUnderstand"
    >
      <div class="main-body buy-bean-body">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="148px"
          class="demo-ruleForm"
        >
          <el-form-item label="购买数量：" required>
            <div class="bean-amount">
              <div class="Note">
                兑换比例（人民币1：{{ Ratio }}发票豆）
              </div>
              <div class="bean-options">
                <div
                  v-for="(item, index) in Arr"
                  :key="'bean-' + index + '-' + item"
                  class="Options"
                  :class="{ 'Select-Options': Amount == item }"
                  @click="handelAmount(item)"
                >
                  {{ item }}
                </div>
              </div>
              <el-form-item
                v-if="Amount == '其它'"
                prop="valNumber"
                class="other-amount-item"
                label-width="0"
              >
                <el-input
                  v-model="ruleForm.valNumber"
                  class="other-amount-input"
                  :placeholder="`请输入其他金额${minPurchase}——${maxPurchase}`"
                  maxlength="30"
                />
              </el-form-item>
            </div>
          </el-form-item>

          <el-form-item label="支付方式：">
            <el-radio-group v-model="payType">
              <el-radio
                v-for="item in payTypeArr"
                :key="'pay-' + item.id"
                :label="item.id"
                >{{ item.name }}</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <el-form-item label="价格：">
            <span class="price-text">￥{{ AmountVal }}元</span>
          </el-form-item>

          <el-form-item label="时长：">
            <span>{{ Moon }}</span>
            <span
              v-if="!isPermanentDuration && expireDate"
              class="expire-text"
              >{{ expireDate }}到期</span
            >
          </el-form-item>
        </el-form>
      </div>
    </dialogModel>
    <CommonPayment
      :VisiblePayment="VisiblePayment"
      :alipayForm="alipayForm"
      :totalAmount="totalAmount"
      :payMethod="payMethod"
      :orderId="orderId"
      :businessType="businessType"
      :businessIntent="5"
      :queryType="'proxy'"
      @handlePayment="handlePayment"
      @handleSuccess="handleSuccess"
    ></CommonPayment>
    <!-- 支付密码验证 -->
    <VerificationPwd
      :VisiblePwd="VisiblePwd"
      @handleClosePwd="VisiblePwd = false"
      @handleUnderstandPwd="handleUnderstandPwd"
    ></VerificationPwd>
  </div>
</template>

<script>
import {
  companyInvoiceBeansCalculatePrice, //计算购买发票豆所需的金额
  pay, //支付接口
  getBeansSetting, //获取发票豆购买数量列表
} from "../../../../../../../../assets/api/Agency/Enterprise";
import * as API from "@/assets/api/Agency/Enterprise.js";
import CommonPayment from "@/components/CommonPayment.vue";
import VerificationPwd from "../IndexCom/VerificationPwd.vue"; //支付密码验证
import { PAYMENT_OPTIONS, DEFAULT_PAYMENT_METHOD } from "@/utils/paymentMethods";

export default {
  props: {
    VisibleBuyBean: {},
  },
  components: { CommonPayment, VerificationPwd },
  data() {
    return {
      payType: DEFAULT_PAYMENT_METHOD,
      payTypeArr: PAYMENT_OPTIONS, //支付方式选择
      alipayForm: ``,
      totalAmount: "",
      businessType: "",
      payMethod: "",
      orderId: "",
      ruleForm: {
        valNumber: "", //
      },
      rules: {
        // 规则未完善
        valNumber: [
          {
            // 改为箭头函数，this 指向 Vue 实例
            validator: (rule, value, callback) => {
              if (!value) return callback();

              // 1. 检查输入是否以 0 开头且长度大于 1（禁止 01、00123 这类格式）
              const valueStr = value.toString().trim();
              if (valueStr.startsWith("0") && valueStr.length > 1) {
                return callback(new Error("不能以0开头"));
              }

              // 2. 原有逻辑：验证是否为正整数
              const num = Number(value);
              if (isNaN(num) || !Number.isInteger(num) || num < 1) {
                return callback(new Error("只能输入0以上的正整数"));
              }

              // 3. 原有逻辑：验证是否在 [minPurchase, maxPurchase] 区间（此处是 100~1000）
              if (num < this.minPurchase || num > this.maxPurchase) {
                return callback(
                  new Error(
                    `请输入${this.minPurchase}~${this.maxPurchase}之间的正整数`
                  )
                );
              }

              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
      },
      Arr: [], //选择金额
      Amount: 0, //金额选择
      VisiblePayment: false,
      paymentPassword: true, //支付密码开启/关闭
      VisiblePwd: false, //支付密码验证
      AmountVal: 0,
      nextYearDate: "", //到期时间
      Moon: "", // 发票豆期限
      Ratio: "", //比例
      maxPurchase: 1000, //最大可购买数
      minPurchase: 1, //最少可购买数
      pwdVerification: "", //密码校验
      selectInput: false, //
      expireDate: "",
      expirationType: null, // 0 永久
    };
  },
  computed: {
    // 时长为永久时不展示到期日期
    isPermanentDuration() {
      return (
        this.expirationType === 0 ||
        this.expirationType === "0" ||
        this.Moon === "永久" ||
        !this.expireDate
      );
    },
  },
  watch: {
    // 监听
    polling: {
      handler(newSs, old) {
        if (newSs == false) {
          clearInterval(this.timer);
        }
      },
      immediate: false,
    },
    tradeStatus: {
      handler(newSs, old) {},
      immediate: false,
    },
    // 监听其它数量  输入框中的值有变化时调用价格计算接口计算价格
    "ruleForm.valNumber": {
      handler(newSs, old) {
        if (newSs != "" && newSs != 0) {
          this.companyInvoiceBeansCalculatePrice(this.ruleForm.valNumber);
        }
      },
      immediate: false,
    },
    // 监听金额选项，选择时清除其它数量输入框的校验与数值
    Amount: {
      handler(newSs, old) {
        if (newSs != "" && newSs != 0 && newSs != "其它") {
          this.ruleForm.valNumber = "";
          // this.AmountVal = 0;
          setTimeout(() => {
            this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
          }, 10);
        }
      },
      immediate: false,
    },
    // 监听弹窗开关
    VisibleBuyBean: {
      handler(newSs, old) {
        if (newSs == false) {
          // 关 ：清除内容
          this.Amount = 0;
          this.ruleForm.valNumber = "";
          this.AmountVal = "0";
          setTimeout(() => {
            this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
          }, 10);
        } else {
          // 开 ：调用接口获取可购买最大值/最小值  选项等数据
          this.getBeansSetting();
        }
      },
      immediate: false,
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 调用接口获取可购买最大值/最小值  选项等数据
    getBeansSetting() {
      API.getBeansSetting().then((res) => {
        this.Arr = res.data.beansCountList;
        this.Arr[this.Arr.length++] = "其它";
        this.Moon = res.data.expirationMonths;
        this.expirationType = res.data.expirationType;
        this.maxPurchase = res.data.highestBuy;
        this.minPurchase = res.data.lowestBuy;
        this.expireDate = res.data.expireDate;
        if (!this.isPermanentDuration) {
          this.getNextYearDate(res.data.expirationMonths);
        }
        this.Ratio = res.data.ratio;
      });
    },
    //付款成功
    handleSuccess() {
      this.VisiblePayment = false;
      this.$emit("handleSuccess");
    },
    getNextYearDate(months) {
      const now = new Date();
      // 关键：直接设置月份（自动处理进位和日期溢出）
      const target = new Date(
        now.getFullYear(),
        now.getMonth() + months,
        now.getDate()
      );

      // 格式化输出（如：2025-11-21）
      const year = target.getFullYear();
      const month = String(target.getMonth() + 1).padStart(2, "0"); // 月份转 1-12
      const day = String(target.getDate()).padStart(2, "0");
      this.nextYearDate = `${year}-${month}-${day}`;
    },
    // 计算金额
    companyInvoiceBeansCalculatePrice(num) {
      // 后台设置的有 最大购买数量与最小购买数量 先判断是否超出
      if (num >= this.minPurchase && num <= this.maxPurchase) {
        var data = {
          data: {
            quantity: num,
          },
        };
        API.companyInvoiceBeansCalculatePrice(data).then((res) => {
          this.AmountVal = res.data;
        });
      } else {
        // 数量超出规定的最大/最小数量
        this.AmountVal = "购买发票豆数量有误";
        // this.$tool.PromptBox(
        //   "error",
        //   "购买数量超出限制的最大值/最小值无法计算价格"
        // );
      }
    },
    // 选择发票豆数量
    handelAmount(item) {
      if (item != "其它") {
        this.Amount = item;
        this.companyInvoiceBeansCalculatePrice(this.Amount);
      } else {
        this.Amount = item;
      }
    },
    // 付款取消
    handlePayment() {
      this.VisiblePayment = false;
    },
    // 关闭弹窗
    handleClose() {
      this.$emit("handleCloseBuyBean");
    },
    //pay支付
    pay() {
      var data = {
        data: {
          businessType: "PROXY_INVOICE_BEANS",
          password: this.pwdVerification,
          businessInfo: {
            quantity:
              this.Amount == "其它" ? this.ruleForm.valNumber : this.Amount,
            months: this.Moon,
            price: this.AmountVal,
          },
          payMethod: this.payType,
          // payMethod: "WECHAT_PAY",
        },
      };
      pay(data).then((res) => {
        if (res.code == 0) {
          this.VisiblePwd = false;
          this.$tool.PromptBox("success", "操作成功");
          this.alipayForm = res.data.payPage;
          this.totalAmount = res.data.totalAmount;
          this.businessType = res.data.businessType;
          this.payMethod = res.data.payMethod;
          this.orderId = res.data.orderId;
          this.VisiblePayment = true;
        } else {
          this.VisiblePwd = false;
        }
      });
    },

    // 支付密码验证通过
    handleUnderstandPwd(pwd) {
      this.pwdVerification = pwd;
      this.pay();
    },
    // 确认
    handleUnderstand() {
      const runPay = () => {
        console.log(this.AmountVal, "this.AmountVal");
        if (this.AmountVal > 0) {
          if (localStorage.getItem("PaymentPwd") == "false") {
            //没有开启支付密码验证直接弹支付二维码
            this.pay();
          } else {
            // 支付密码验证
            this.VisiblePwd = true;
          }
        } else {
          this.$tool.PromptBox(
            "error",
            "请选择或输入要购买的发票豆数量，价格计算成功后在进行购买"
          );
        }
      };
      if (this.Amount == "其它") {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            runPay();
          } else {
            return false;
          }
        });
      } else {
        runPay();
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "../bookkeeping-form-dialog.less";

.buy-bean-body {
  max-width: 640px;
  margin: 0 auto;
}
.bean-amount {
  width: 100%;
}
.Note {
  width: 100%;
  font-size: 12px;
  color: #409eff;
  line-height: 22px;
  margin-bottom: 8px;
}
.bean-options {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  max-width: 100%;
}
.other-amount-item {
  width: 100%;
  margin: 10px 0 0 !important;
}
.other-amount-input {
  width: 360px !important;
}
.price-text {
  color: #fe574a;
}
.expire-text {
  margin-left: 20px;
}
</style>
